export function formatListOfBreaks(breaksList) {
  let list = [];
  const allBreaks = breaksList.map((item) => {
    return item.title;
  });
  allBreaks
    .filter((item, index, array) => array.indexOf(item) === index)
    .map((item) => {
      const minBreak = parseInt(item.split("Min: ")[1].split(" mins")[0]);
      const maxBreak = parseInt(item.split("Max: ")[1].split(" mins")[0]);
      return list.push({ min: minBreak, max: maxBreak });
    });
  return list;
}
